// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Jci7","rightAdornment":"Header_rightAdornment__fOggG"};